<mat-card class="layout-container" [attr.data-testid]="testIds.containerEmptychat">
  <mat-card-content [attr.data-testid]="testIds.containerEmptychatmessage">
    Es ist kein Chat ausgewählt.
    <app-create-room-dialog></app-create-room-dialog>
  </mat-card-content>
</mat-card>
